/* eslint-disable @typescript-eslint/ban-ts-comment */
// @ts-nocheck
import { PropsWithChildren } from 'react';
import { Link, To } from 'react-router-dom';

const ConditionalLink = ({
  className,
  href,
  onClick,
  children,
  external,
  asButton,
  target,
  style,
}: PropsWithChildren<{
  className?: string;
  href?: To | false | null;
  onClick?: React.MouseEventHandler<HTMLElement>;
  external?: boolean;
  asButton?: boolean;
  target?: React.HTMLAttributeAnchorTarget;
  style?: React.CSSProperties;
}>) => {
  const content = asButton ? (
    <button type="button" className={className} style={style} onClick={onClick}>
      {children}
    </button>
  ) : (
    <p className={className} style={style} onClick={onClick}>
      {children}
    </p>
  );

  if (!href) {
    return content;
  }

  return (
    <Link
      className={className}
      style={{
        color: 'unset',
        fontWeight: 'unset',
        ...style,
      }}
      to={href}
      {...(target != null
        ? { target }
        : external
          ? { target: '_blank', rel: 'noreferrer' }
          : { target: '_self' })}
      onClick={onClick}
    >
      {children}
    </Link>
  );
};

export default ConditionalLink;
